import { render, staticRenderFns } from "./edit-compra.vue?vue&type=template&id=333f2342"
import script from "./edit-compra.vue?vue&type=script&lang=js"
export * from "./edit-compra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports